import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';

type ArticleRecommendWidget = {
  isOpen: boolean;
  id: number;
  code?: string;
};

export const useArticleRecommend = () => {
  const { doSetStorageData, doRemoveStorageData, data } = useSaveData<
    Partial<ArticleRecommendWidget>
  >('ArticleRecommendModalState');

  const closeModal = useCallback(() => doRemoveStorageData(), [doRemoveStorageData]);

  const openModal = useCallback(
    ({ code, id }: { id: number; code?: string }) =>
      doSetStorageData({
        id,
        isOpen: true,
        code,
      }),
    [doSetStorageData]
  );

  return {
    isModalOpen: data?.isOpen || false,
    articleId: data?.id,
    code: data?.code,
    closeModal,
    openModal,
  };
};
